import React from "react";

export interface BadgeProps {
    value: number | null | undefined | string;
    type: "error" | "info" | "highlight" | "success";
    important?: boolean;
}

const styles = {
    error: "bg-red-100 text-red-600",
    info: "bg-gray-200 text-gray-700 ",
    highlight: "bg-brand-200 text-brand-700",
    success: "bg-green-100 text-green-600",
};

export const Badge: React.FC<BadgeProps> = props => {
    const { value, type, important = false } = props;
    if (value === undefined || value === null || value === "") return null;

    const animationClass = important ? "animate-pulse" : "";

    return (
        <div
            className={`font-bold text-xs rounded-full ${styles[type]} inline px-2 py-0 ${animationClass}`}>
            {value}
        </div>
    );
};
